<div class="modal-header">
    <h4 class="modal-title">Hesap {{data == null ? 'Oluştur' : 'Düzenle'}}</h4>
</div>
<div class="modal-body">
    <form [formGroup]="vaultForm">
        <div class="col-12">
            <label for="title">Başlık</label>
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" id="title" formControlName="title" />
                </div>
                <div *ngIf="vaultForm.get('title').invalid && vaultForm.get('title').touched" class="text-danger">
                    Başlık zorunludur.
                </div>
            </div>
        </div>
        <div class="col-12">
            <label for="description">Açıklama</label>
            <div class="form-group">
                <div class="input-group">
                    <textarea class="form-control" id="description" formControlName="description"></textarea>
                </div>
            </div>
        </div>
        <div class="col-12">
            <label>İşlem Türü</label>
            <div class="form-group">
                <ng-select [items]="kinds" bindLabel="typeName" formControlName="kind">
                </ng-select>
                <div *ngIf="vaultForm.get('kind').invalid && vaultForm.get('kind').touched" class="text-danger">
                    İşlem Türü zorunludur.
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="row d-flex w-100 justify-content-between">
        <div>
            <button *ngIf="data != null" type="button" class="btn btn-danger" appDelete controller="vaults"
                [message]="deleteMessage" [id]="data?.id" (callback)="eventDelete()">Hesabı Sil</button>
        </div>
    
        <div>
            <button type="button" class="btn btn-success mr-1" [disabled]="vaultForm.invalid" (click)="save()">
                {{ data == null ? 'Kaydet' : 'Güncelle' }}
            </button>
            <button type="button" class="btn btn-warning ms-2" (click)="closeModal()">İptal</button>
        </div>
    </div>
    
</div>